export enum YardOperations {
  SPOT = 'Spot',
  PULL = 'Pull',
  PULLSPOT = 'PullSpot',
  BUMP = 'Bump',
  FUEL = 'Fuel',
  WASH = 'Wash',
  YARD = 'Yard',
  TEMPCHANGE = 'TemperatureChange',
  SHUTTLE = 'Shuttle',
}
